<template>
  <!-- 证据链 -->
  <div>
    <div id="enterprise-evidence">
      <div
        v-if="tabActive.tab2Active == '客户合同'"
        class="enterprise-evidence-type"
      >
        <div class="enterprise-evidence-item" id="客户合同">
          <div class="enterprise-evidence-item-title">
            <div class="title">
              客户合同 ({{ clientEvidenceInfo.pageData.totalCount }})
            </div>
            <div style="flex: 1"></div>
            <div class="enterprise-evidence-item-title-search">
              <div class="search-item">
                <el-input
                  v-model="clientEvidenceInfo.searchData.name"
                  placeholder="请输入合同名称"
                  @keyup.enter.native="getClientEvidenceInfo"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click.native.stop="getClientEvidenceInfo"
                  ></el-button>
                </el-input>
              </div>
              <div class="search-item">
                <el-select
                  v-model="clientEvidenceInfo.searchData.status"
                  placeholder="请选择合同状态"
                  @change="getClientEvidenceInfo"
                  clearable
                >
                  <el-option label="执行中" value="执行中"></el-option>
                  <el-option label="已结束" value="已结束"></el-option>
                  <el-option label="全部" value=""></el-option>
                </el-select>
              </div>
              <div class="search-item">
                <el-select
                  v-model="clientEvidenceInfo.searchData.type"
                  placeholder="请选择合同类型"
                  @change="getClientEvidenceInfo"
                  clearable
                >
                  <el-option label="常规合同" value="常规合同"></el-option>
                  <el-option label="框架合同" value="框架合同"></el-option>
                </el-select>
              </div>
              <div class="search-item">
                <el-date-picker
                  v-model="clientEvidenceInfo.searchData.signingDate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="签约时间"
                  end-placeholder="签约时间"
                  value-format="yyyy-MM-dd"
                  @change="getClientEvidenceInfo"
                >
                </el-date-picker>
              </div>
            </div>
            <el-button type="primary" plain size="mini" @click="addEvidence"
              >新增</el-button
            >
          </div>
          <div class="enterprise-evidence-item-value">
            <enterpriseTable
              :table="clientEvidenceInfo"
              :clientInfo="clientInfo"
              :allFunctionButtons="allFunctionButtons"
              @linkDialog="linkDialog"
              @addEvidence="addEvidence"
              @editEvidence="editEvidence"
              @deleteEvidence="deleteEvidence"
            />
          </div>
        </div>
      </div>
      <div
        v-if="tabActive.tab2Active == '供应商合同'"
        class="enterprise-evidence-type"
      >
        <div class="enterprise-evidence-item" id="供应商合同">
          <div class="enterprise-evidence-item-title">
            <div class="title">
              供应商合同 ({{ supplierEvidenceInfo.pageData.totalCount }})
            </div>
            <div style="flex: 1"></div>
            <div class="enterprise-evidence-item-title-search">
              <div class="search-item">
                <el-input
                  v-model="supplierEvidenceInfo.searchData.name"
                  placeholder="请输入合同名称"
                  @keyup.enter.native="getSupplierEvidenceInfo"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click.native.stop="getSupplierEvidenceInfo"
                  ></el-button>
                </el-input>
              </div>
              <div class="search-item">
                <el-select
                  v-model="supplierEvidenceInfo.searchData.status"
                  placeholder="请选择合同状态"
                  @change="getSupplierEvidenceInfo"
                  clearable
                >
                  <el-option label="执行中" value="执行中"></el-option>
                  <el-option label="已结束" value="已结束"></el-option>
                  <el-option label="全部" value=""></el-option>
                </el-select>
              </div>
              <div class="search-item">
                <el-select
                  v-model="supplierEvidenceInfo.searchData.type"
                  placeholder="请选择合同类型"
                  @change="getSupplierEvidenceInfo"
                  clearable
                >
                  <el-option label="常规合同" value="常规合同"></el-option>
                  <el-option label="框架合同" value="框架合同"></el-option>
                </el-select>
              </div>
              <div class="search-item">
                <el-date-picker
                  v-model="supplierEvidenceInfo.searchData.signingDate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="签约时间"
                  end-placeholder="签约时间"
                  value-format="yyyy-MM-dd"
                  @change="getSupplierEvidenceInfo"
                >
                </el-date-picker>
              </div>
            </div>
            <el-button type="primary" plain size="mini" @click="addEvidence"
              >新增</el-button
            >
          </div>
          <div class="enterprise-evidence-item-value">
            <enterpriseTable
              :table="supplierEvidenceInfo"
              :clientInfo="clientInfo"
              :allFunctionButtons="allFunctionButtons"
              @linkDialog="linkDialog"
              @addEvidence="addEvidence"
              @editEvidence="editEvidence"
              @deleteEvidence="deleteEvidence"
            />
          </div>
        </div>
      </div>
    </div>
    <div id="my-dialog" v-if="dialogData.flag">
      <my_dialog7
        :width="dialogData.width"
        :title="dialogData.title"
        :buttonArray="dialogData.buttonArray"
        :dialogStyle="dialogData.dialogStyle"
        :data="dialogData.data"
        @colseDialog="colseDialog"
        @dialogOper="drawerOper"
        @buttonOper="drawerOper"
        @drawerOperByTable="drawerOperByTable"
        @changeFlag="changeFlag"
      ></my_dialog7>
    </div>
    <div id="my-dialog3" v-if="dialogData3.flag">
      <my_dialog7
        :width="dialogData3.width"
        :title="dialogData3.title"
        :buttonArray="dialogData3.buttonArray"
        :dialogStyle="dialogData3.dialogStyle"
        :data="dialogData3.data"
        @colseDialog="colseDialog3"
        @dialogOper="drawerOper"
        @buttonOper="drawerOper"
      ></my_dialog7>
    </div>
  </div>
</template>

<script>
import enterpriseTable from "@/components/enterprise-components/enterprise-table";
import * as invoiceData from "@/assets/js/invoiceData.js";
export default {
  components: {
    enterpriseTable,
  },
  props: {
    clientInfo: {
      type: Object,
      default: () => {},
    },
    tabActive: {
      type: Object,
      default: () => {},
    },
    enterpriseInfo: {
      type: Object,
      default: () => {},
    },
    department: {
      type: String,
      default: "",
    },
    userIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      baseInfo: {},
      dialogData: {
        flag: false,
        width: "45%",
        title: "新建报销",
        buttonArray: [],
        data: [],
      },
      dialogData3: {
        flag: false,
        width: "45%",
        title: "新建报销",
        buttonArray: [],
        data: [],
      },
      clientEvidenceInfo: {
        type: "clientEvidenceInfo",
        searchData: {
          name: "",
          signingDate: [],
          status: "执行中",
          type: "",
        },
        tempData: {},
        tableData: [],
        tableMenu: [
          {
            prop: "name",
            label: "合同名称",
            width: "200",
          },
          {
            prop: "type",
            label: "合同类型",
            width: "100",
          },
          {
            prop: "status",
            label: "合同状态",
            width: "100",
          },
          {
            prop: "clientName", // todo
            label: "客户全称",
            width: "200",
          },
          {
            prop: "contractAmount",
            label: "合同金额",
            width: "90",
          },
          {
            prop: "invoiceAmount",
            label: "开票金额",
            width: "90",
          },
          {
            prop: "paymentAmount",
            label: "回款金额",
            width: "90",
          },
          {
            prop: "arrears",
            label: "欠款金额",
            width: "90",
          },
          {
            prop: "signingDate",
            label: "签约时间",
            width: "120",
          },
          {
            prop: "createUser",
            label: "创健人",
            width: "150",
          },
          {
            prop: "gmtCreate",
            label: "创健时间",
            width: "180",
          },
          {
            prop: "evidenceStatus",
            label: "合同附件",
            width: "80",
            active: "evidence",
            type: "link_dialog",
            fixed: "right",
          },
          {
            prop: "invoice",
            label: "发票信息",
            width: "80",
            active: "invoice",
            type: "link_dialog",
            fixed: "right",
          },
        ],
        buttonInfo: {
          width: "140px",
          list: [
            {
              text: "编辑",
              active: "edit_evidence",
              type: "primary",
              size: "mini",
              authority: "editContract",
            },
            {
              text: "删除",
              active: "delete_evidence",
              type: "danger",
              size: "mini",
              authority: "editContract", // todo
            },
          ],
        },
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
      },
      supplierEvidenceInfo: {
        type: "supplierEvidenceInfo",
        searchData: {},
        tableData: [],
        tableMenu: [
          {
            prop: "name",
            label: "合同名称",
            width: "200",
          },
          {
            prop: "type",
            label: "合同类型",
            width: "100",
          },
          {
            prop: "status",
            label: "合同状态",
            width: "100",
          },
          {
            prop: "supplierName", // todo
            label: "供应商全称",
            width: "200",
          },
          {
            prop: "contractAmount",
            label: "合同金额",
            width: "90",
          },
          {
            prop: "invoiceAmount",
            label: "开票金额",
            width: "90",
          },
          {
            prop: "paymentAmount",
            label: "回款金额",
            width: "90",
          },
          {
            prop: "arrears",
            label: "欠款金额",
            width: "90",
          },
          {
            prop: "signingDate",
            label: "签约时间",
            width: "120",
          },
          {
            prop: "createUser",
            label: "创健人",
            width: "150",
          },
          {
            prop: "gmtCreate",
            label: "创健时间",
            width: "180",
          },
          {
            prop: "evidenceStatus",
            label: "合同附件",
            width: "80",
            active: "evidence",
            type: "link_dialog",
            fixed: "right",
          },
          {
            prop: "invoice",
            label: "发票信息",
            width: "80",
            active: "invoice",
            type: "link_dialog",
            fixed: "right",
          },
        ],
        buttonInfo: {
          width: "140px",
          list: [
            {
              text: "编辑",
              active: "edit_evidence",
              type: "primary",
              size: "mini",
              authority: "editContract",
            },
            {
              text: "删除",
              active: "delete_evidence",
              type: "danger",
              size: "mini",
              authority: "editContract", // todo
            },
          ],
        },
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
      },
      allFunctionButtons:
        this.$featureData.getAllFunctionButtons("dispatchInfo"),
    };
  },
  watch: {
    "tabActive.tab2Active": {
      handler(newValue, oldValue) {
        this.changeTab();
      },
    },
  },
  methods: {
    getModelFeatureAuthority() {
      console.log("获取权限");
      this.$authority.getModelFeatureAuthority(
        this,
        "dispatchInfo",
        this.allFunctionButtons,
        (data) => {
          this.allFunctionButtons = data;
        },
      );
    },
    changeTab() {
      switch (this.tabActive.tab2Active) {
        case "客户合同":
          this.getClientEvidenceInfo();
          break;
        case "供应商合同":
          this.getSupplierEvidenceInfo();
          break;
        default:
          break;
      }
    },
    // 客户合同
    getClientEvidenceInfo() {
      let requestData = {
        companyId: this.baseInfo.company.companyId,
        clientId: this.clientInfo.id,
        contractCategory: 2, // 合同分类：1-供应商合同 2-客户合同
        name: this.clientEvidenceInfo.searchData.name, // 合同名称
        type: this.clientEvidenceInfo.searchData.type, // 合同类型：常规合同、框架合同
        status: this.clientEvidenceInfo.searchData.status, // 合同状态：执行中、已结束
        signingDate: this.clientEvidenceInfo.searchData.signingDate, // 签约时间
        userIds: this.userIds,
        department:
          this.department.length > 0
            ? this.department[this.department.length - 1]
            : "",
        currentPage: this.clientEvidenceInfo.pageData.pageIndex, // 当前页
        pageSize: this.clientEvidenceInfo.pageData.pageSize, // 每页数量
      };
      this.$request(
        "post",
        "/compliantContract/queryPage",
        requestData,
        (data) => {
          this.clientEvidenceInfo.tableData = data.records;
          this.clientEvidenceInfo.pageData.totalCount = data.total;
          this.clientEvidenceInfo.tableData.forEach((item) => {
            item.invoice = "点击查看";
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 供应商合同 todo
    getSupplierEvidenceInfo() {
      let requestData = {
        clientId: this.clientInfo.id,
        contractCategory: 1, // 合同分类：1-供应商合同 2-客户合同
        name: this.supplierEvidenceInfo.searchData.name, // 合同名称
        type: this.supplierEvidenceInfo.searchData.type, // 合同类型：常规合同、框架合同
        status: this.supplierEvidenceInfo.searchData.status, // 合同状态：执行中、已结束
        signingDate: this.supplierEvidenceInfo.searchData.signingDate, // 签约时间
        userIds: this.userIds,
        department:
          this.department.length > 0
            ? this.department[this.department.length - 1]
            : "",
        currentPage: this.supplierEvidenceInfo.pageData.pageIndex, // 当前页
        pageSize: this.supplierEvidenceInfo.pageData.pageSize, // 每页数量
      };
      this.$request(
        "post",
        "/compliantContract/queryPage",
        requestData,
        (data) => {
          this.supplierEvidenceInfo.tableData = data.records;
          this.supplierEvidenceInfo.pageData.totalCount = data.total;
          this.supplierEvidenceInfo.tableData.forEach((item) => {
            item.invoice = "点击查看";
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    linkDialog(data) {
      if (this.tabActive.tab2Active == "客户合同") {
        this.clientEvidenceInfo.tempData = data.row;
      } else if (this.tabActive.tab2Active == "供应商合同") {
        this.supplierEvidenceInfo.tempData = data.row;
      }
      console.log("");
      switch (data.prop) {
        case "evidenceStatus":
          this.dialogData.width = "800px";
          this.dialogData.title = "合同附件";
          this.dialogData.buttonArray = [
            {
              text: "上传",
              active: "upload",
            },
            {
              text: "取消",
              active: "cancel",
            },
          ];
          this.dialogData.data = [
            {
              title: "",
              type: "table",
              height: "400px",
              data: data.row.evidenceList,
              props: [
                {
                  prop: "name",
                  label: "文件名称",
                  type: "link",
                  url: "uri",
                },
                {
                  prop: "suitableSize",
                  label: "文件大小",
                  type: "text",
                  width: "110",
                },
                {
                  prop: "gmtCreate",
                  label: "上传时间",
                  type: "text",
                  width: "160",
                },
                {
                  prop: "",
                  label: "操作",
                  width: "100",
                  type: "buts",
                  buts: [
                    {
                      type: "danger",
                      name: "删除",
                      active: "delete",
                    },
                  ],
                },
              ],
            },
          ];
          this.dialogData.flag = true;
          break;
        case "invoice":
          this.dialogData.width = "800px";
          this.dialogData.title = "合同发票";
          this.dialogData.buttonArray = [];
          let compliantContractId = "";
          if (this.tabActive.tab2Active == "客户合同") {
            compliantContractId = this.clientEvidenceInfo.tempData.id;
          } else if (this.tabActive.tab2Active == "供应商合同") {
            compliantContractId = this.supplierEvidenceInfo.tempData.id;
          }
          this.$request(
            "get",
            "/invoice/compliantContractId?compliantContractId=" +
              compliantContractId,
            {},
            (data) => {
              let result = invoiceData.transTableData(data);
              this.dialogData.data = [
                {
                  type: "table",
                  height: "400px",
                  value: "",
                  data: result,
                  props: [
                    {
                      prop: "buyerName",
                      label: "购方名称",
                      width: "150",
                      type: "text",
                    },
                    {
                      prop: "type",
                      label: "发票种类",
                      width: "100",
                      type: "text",
                    },
                    {
                      prop: "totalAmount",
                      label: "开票金额",
                      width: "100",
                      type: "text",
                    },
                    {
                      prop: "status",
                      label: "状态",
                      width: "100",
                      type: "text",
                    },
                    {
                      prop: "createUserName",
                      label: "创建人",
                      width: "150",
                      type: "text",
                    },
                    {
                      prop: "gmtCreate",
                      label: "创健日期",
                      type: "text",
                    },
                  ],
                },
              ];
              this.dialogData.flag = true;
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
          break;
        default:
          break;
      }
    },
    drawerOper(active) {
      let requestData = {};
      let flag = false;
      switch (active) {
        case "add_evidence":
          // todo
          requestData = {
            contractCategory: "", // 客户合同
            clientId: this.clientInfo.id,
          };
          this.dialogData.data.forEach((item) => {
            requestData[item.key] = item.value;
            if (item.key == "contractAmount") {
              requestData[item.key] = item.value.toFixed(2);
            }
            if (!requestData[item.key] && item.required) flag = true;
          });
          if (flag) {
            return this.$message.error("请将必填信息填写完整!");
          }
          if (this.tabActive.tab2Active == "客户合同") {
            requestData.contractCategory = "2";
          } else if (this.tabActive.tab2Active == "供应商合同") {
            requestData.contractCategory = "1";
          }
          this.$request(
            "post",
            "/compliantContract/add",
            requestData,
            (data) => {
              this.$message.success("合同新建成功!");
              this.dialogData.flag = false;
              this.changeTab();
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
          break;
        case "edit_evidence":
          requestData = {
            id: "",
            contractCategory: "", // 客户合同
            clientId: this.clientInfo.id,
          };
          this.dialogData.data.forEach((item) => {
            requestData[item.key] = item.value;
            if (item.key == "paymentAmount") {
              requestData[item.key] = item.value.toFixed(2);
            }
            if (item.key == "contractAmount") {
              requestData[item.key] = item.value.toFixed(2);
            }
            if (!requestData[item.key] && item.required) flag = true;
          });
          if (flag) {
            return this.$message.error("请将必填信息填写完整!");
          }
          if (this.tabActive.tab2Active == "客户合同") {
            requestData.contractCategory = "2";
            requestData.id = this.clientEvidenceInfo.tempData.id;
          } else if (this.tabActive.tab2Active == "供应商合同") {
            requestData.contractCategory = "1";
            requestData.id = this.supplierEvidenceInfo.tempData.id;
          }
          this.$request(
            "post",
            "/compliantContract/update",
            requestData,
            (data) => {
              this.$message.success("合同编辑成功!");
              this.dialogData.flag = false;
              this.changeTab();
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
          break;
        case "upload":
          this.uploadEvidenceFile();
          break;
        case "cancel":
          if (this.dialogData3.flag) {
            this.colseDialog3();
          } else {
            this.colseDialog();
          }
          break;
        default:
          break;
      }
    },
    colseDialog() {
      this.dialogData.flag = false;
    },
    colseDialog3() {
      this.dialogData3.flag = false;
    },
    uploadEvidenceFile() {
      let fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "*/*";
      fileInput.onchange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        let formData = new FormData();
        let compliantContractId = "";
        if (this.tabActive.tab2Active == "客户合同") {
          compliantContractId = this.clientEvidenceInfo.tempData.id;
        } else if (this.tabActive.tab2Active == "供应商合同") {
          compliantContractId = this.supplierEvidenceInfo.tempData.id;
        }
        formData.append("compliantContractId", compliantContractId);
        formData.append("renewUserId", this.baseInfo.userId);
        formData.append("name", file.name);
        formData.append("mf", file);
        this.$requestByFormData(
          "post",
          "/compliantContract/updateEvidence",
          formData,
          (result) => {
            this.$message.success("上传成功!");
            if (this.tabActive.tab2Active == "客户合同") {
              this.clientEvidenceInfo.tempData.evidenceList.push(result);
              this.$set(
                this.dialogData.data[0],
                "data",
                this.clientEvidenceInfo.tempData.evidenceList,
              );
            } else if (this.tabActive.tab2Active == "供应商合同") {
              this.supplierEvidenceInfo.tempData.evidenceList.push(result);
              this.$set(
                this.dialogData.data[0],
                "data",
                this.supplierEvidenceInfo.tempData.evidenceList,
              );
            }

            this.changeTab();
          },
          (errorMessage) => {
            this.$message.error(errorMessage);
          },
        );
      };
      fileInput.click();
    },
    drawerOperByTable(data) {
      let requestData = {};
      switch (data.active) {
        // 删除合同附件
        case "delete":
          this.$confirm("确认删除当前合同附件吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              requestData = {
                compliantContractId: this.clientEvidenceInfo.tempData.id, // 合规合同 id
                fileManageId: data.row.id, // 要删除的文件id
                renewUserId: this.baseInfo.userId, // 操作人 id
              };
              this.$request(
                "post",
                "/compliantContract/delEvidence",
                requestData,
                (result) => {
                  this.$message.success("删除成功!");
                  this.getClientEvidenceInfo();
                  //通过id删除表格数据中的当前行
                  let array = this.dialogData.data[0].data.filter(
                    (item) => item.id !== data.row.id,
                  );
                  this.$set(this.dialogData.data[0], "data", array);
                  // 同步更新 tempData.evidenceList，避免后续上传时带入已删除的数据
                  if (this.tabActive.tab2Active == "客户合同") {
                    this.clientEvidenceInfo.tempData.evidenceList = array;
                  } else {
                    this.supplierEvidenceInfo.tempData.evidenceList = array;
                  }
                },
                (errorMessage) => {
                  this.$message.error(errorMessage);
                },
              );
            })
            .catch(() => {});
          break;
        default:
          break;
      }
    },
    changeFlag(val) {
      this.dialogData.data.forEach((item) => {
        if (item.key == "contractAmount") {
          // 修改合同类型
          item.value = 0;
          if (val == "常规合同") {
            item.flag = false;
          } else {
            // 框架合同
            item.flag = true;
          }
        }
      });
    },
    // 新增客户/供应商合同
    addEvidence() {
      this.dialogData.width = "600px";
      this.dialogData.title = "新建客户合同";
      this.dialogData.buttonArray = [
        { text: "确认", active: "add_evidence" },
        {
          text: "取消",
          active: "cancel",
        },
      ];
      this.dialogData.data = [
        {
          title: "合同主体",
          type: "text",
          value: this.clientInfo.clientName,
          required: true,
        },
        {
          title: "客户全称",
          type: "input",
          key: "clientName",
          value: "",
          placeholder: "请输入客户全称",
          required: true,
        },
        {
          title: "合同名称",
          type: "input",
          key: "name",
          value: "",
          placeholder: "请输入合同名称",
          required: true,
        },
        {
          title: "合同类型",
          type: "radio",
          key: "type",
          value: "常规合同",
          options: [
            {
              value: "常规合同",
              label: "常规合同",
            },
            {
              value: "框架合同",
              label: "框架合同",
            },
          ],
          required: true,
        },
        {
          title: "合同金额",
          type: "input-number",
          key: "contractAmount",
          value: "",
          flag: false,
          placeholder: "请输入合同金额",
          required: true,
        },

        {
          title: "签约时间",
          type: "time_date",
          key: "signingDate",
          value: "",
          required: true,
        },
        {
          title: "合同状态",
          type: "switch",
          key: "status",
          value: "执行中",
          activeText: "执行中",
          inactiveText: "已结束",
          activeValue: "执行中",
          inactiveValue: "已结束",
          options: [
            {
              value: "执行中",
              label: "执行中",
            },
            {
              value: "已结束",
              label: "已结束",
            },
          ],
        },
      ];
      if (this.tabActive.tab2Active == "供应商合同") {
        this.dialogData.title = "新建供应商合同";
        this.$set(this.dialogData.data, 1, {
          title: "供应商全称",
          type: "input",
          key: "supplierName",
          value: "",
          placeholder: "请输入供应商全称",
          required: true,
        });
      }
      this.dialogData.flag = true;
    },
    // 编辑客户/供应商合同
    editEvidence(row) {
      if (this.tabActive.tab2Active == "供应商合同") {
        this.supplierEvidenceInfo.tempData = row;
      } else {
        this.clientEvidenceInfo.tempData = row;
      }
      this.dialogData.width = "600px";
      this.dialogData.title = "编辑客户合同";
      this.dialogData.buttonArray = [
        {
          text: "确认",
          active: "edit_evidence",
        },
        {
          text: "取消",
          active: "cancel",
        },
      ];
      this.dialogData.data = [
        {
          title: "合同主体",
          type: "text",
          value: this.clientInfo.clientName,
          required: true,
        },
        {
          title: "客户全称",
          type: "input",
          key: "clientName",
          value: row.clientName,
          placeholder: "请输入客户全称",
          required: true,
        },
        {
          title: "合同名称",
          type: "input",
          key: "name",
          value: row.name,
          placeholder: "请输入合同名称",
          required: true,
        },
        {
          title: "合同类型",
          type: "radio",
          key: "type",
          value: row.type,
          options: [
            {
              value: "常规合同",
              label: "常规合同",
            },
            {
              value: "框架合同",
              label: "框架合同",
            },
          ],
          required: true,
        },
        {
          title: "合同金额",
          type: "input-number",
          key: "contractAmount",
          value: row.contractAmount,
          flag: row.type == "常规合同" ? false : true,
          placeholder: "请输入合同金额",
          required: true,
        },
        {
          title: "回款金额",
          type: "input-number",
          key: "paymentAmount",
          value: row.paymentAmount,
          required: true,
        },
        {
          title: "签约时间",
          type: "time_date",
          key: "signingDate",
          value: row.signingDate,
          required: true,
        },
        {
          title: "合同状态",
          type: "switch",
          key: "status",
          value: row.status,
          activeValue: "执行中",
          inactiveValue: "已结束",
          activeText: "执行中",
          inactiveText: "已结束",
        },
      ];
      if (this.tabActive.tab2Active == "供应商合同") {
        this.dialogData.title = "编辑供应商合同";
        this.$set(this.dialogData.data, 1, {
          title: "供应商全称",
          type: "input",
          key: "supplierName",
          value: row.supplierName,
          placeholder: "请输入供应商全称",
          required: true,
        });
      }
      this.dialogData.flag = true;
    },
    // 删除客户/供应链合同
    deleteEvidence(row) {
      this.$confirm("确认删除当前合同吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let requestData = {
            id: row.id,
          };
          this.$request(
            "post",
            "/compliantContract/delete",
            requestData,
            (data) => {
              this.$message.success("删除成功!");
              this.changeTab();
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.baseInfo = JSON.parse(sessionStorage.getItem("userData"));
    this.getModelFeatureAuthority();
    this.changeTab();
  },
};
</script>

<style lang="less" scoped>
#enterprise-evidence {
  width: 100%;
  background-color: #fff;
  .enterprise-evidence-type {
    width: 100%;
    .enterprise-evidence-item {
      width: 100%;
      margin-top: 32px;
      scroll-margin-top: 180px;
      &:first-child {
        margin-top: 0;
      }

      .enterprise-evidence-item-title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        .title {
          // 不换行
          white-space: nowrap;
          margin-right: 12px;
        }
        .enterprise-evidence-item-title-search {
          display: flex;
          .search-item {
            margin-right: 5px;
            max-width: 200px;
          }
        }
        /deep/ .el-button {
          padding: 8px 15px;
        }
      }
      .enterprise-evidence-item-tag {
        display: flex;
        margin: 12px 0;
        .tag {
          font-size: 14px;
          color: #777e95;
          cursor: pointer;
          height: 28px;
          padding: 0 12px;
          line-height: 28px;
          cursor: pointer;
          border-radius: 14px;
        }
        .is-active {
          color: #327bf9;
          background: #eaf2ff;
        }
        .is-disabled {
          color: #c3c8da;
          cursor: not-allowed;
        }
      }
      .enterprise-evidence-item-value {
        width: 100%;
        .text {
          width: 100%;
          padding: 15px 23px;
          font-size: 14px;
          line-height: 24px;
          text-align: left;
          box-sizing: border-box;
          background: #f6f8fb
            url(https://51nbimg.u51.com/62c9ea111656463a90e8c968177a5d5d.png)
            right bottom / 102px 102px no-repeat;
        }
        .table-text {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .table-text-item {
            width: 100%;
            height: 100%;
            display: flex;
            font-size: 14px;
            border: 1px solid #eff1f8;
            color: #111a34;

            .table-text-item-title {
              background-color: #f9fafc;
              width: 145px;
              min-width: 145px;
              text-align: right;
              padding: 13px 16px;
              box-sizing: border-box;
              color: #777e95;
              border-right: 1px solid #eff1f8;
            }
            .table-text-item-value {
              width: 80%;
              padding: 13px 16px;
              box-sizing: border-box;
              text-align: left;
              word-wrap: break-word;
              word-break: normal;
            }
          }
          .gather {
            .table-text-item-line {
              display: flex;
              &:last-child .table-text-item-value {
                border-bottom: 0;
              }
              .table-text-item-value {
                border-right: 1px solid #eff1f8;
                border-bottom: 1px solid #eff1f8;
                &:nth-child(even) {
                  border-right: 0;
                }
              }
            }
          }
        }
      }
    }
  }
  .activeColor {
    color: #327bf9 !important;
    cursor: pointer;
  }
}
</style>
